import { ProjectId } from 'api/models';
import { FetchStatus } from '../core';
import { RootState } from '../index';
import { Space } from './schema';
import { SpaceState } from './slice';

export const getAllSpacesByProjectId =
  ([, projectId]: ProjectId) =>
  (state: RootState) =>
    state.spaces.items[projectId];

export const getSpacesCreating = (state: RootState): boolean =>
  state.spaces.creating;

export const spacesSelector = (state: RootState): Space[] =>
  Object.values(state.spaces.items);

export const getSpaceByIdSelector =
  (spaceId: number) =>
  ({ spaces }: RootState): Space =>
    spaces.items[spaceId];

export const selectSpaceFetchStatus =
  (spaceId: number) =>
  ({ spaces }: RootState): FetchStatus =>
    spaces.itemsFetchStatus[spaceId];

export const getCurrentSpaceSelector = ({ spaces }: RootState) =>
  spaces.currentSpace;

export const isDeletingSelector = ({ spaces }: RootState): boolean =>
  spaces.deleting;

export const isEditingSelector = ({ spaces }: RootState): boolean =>
  spaces.isEditing;

/**
 * @function isEditSelector
 * @param spaces
 * @return boolean
 */
export const isEditSelector = ({ spaces }: RootState): boolean => spaces.edit;

/**
 * @function spacesStateSelector
 * @param state
 * @return SpaceState
 */
export const spacesStateSelector = (state: RootState): SpaceState =>
  state.spaces;

const getSpacesByProjectId = (
  spaces: Space[],
  [, projectId]: ProjectId,
): Space[] => Object.values(spaces).filter((s) => s.project === projectId);

export const spacesByProjectIdSelector =
  (projectId: ProjectId) =>
  (state: RootState): Space[] =>
    getSpacesByProjectId(spacesSelector(state), projectId);
